<template>
  <div class="about" @click="change()">
    <h1>This is an about page</h1>
    <!-- <vue-editor v-model="content"></vue-editor> -->
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
    >
    </quill-editor>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
// import { VueEditor } from "vue2-editor";

export default {
  name: "Student",
  components: {
    quillEditor,
  },
  data() {
    return {
      content: "<h1>Some initial content</h1>",
      editorOption: {},
    };
  },
  methods: {
    change: function () {
      console.log("aha");
    },
    onEditorBlur: function () {
      console.log("onEditorBlur");
    },
    onEditorFocus: function () {
      console.log("onEditorBlur");
    },
    onEditorReady: function () {
      console.log("onEditorBlur");
    },
  },
};
</script>
